import React, { useEffect, useState } from "react";

import { Navigate } from 'react-router-dom';
import useGetSession from "../../hooks/useGetSession";

interface Comp {
    component?: React.ElementType;
}

const AuthGuard = (props: any) => {
    const {component: Comp} = props;
    const [getSession] = useGetSession();
  
    const getSessionInfo = async () =>{
      const { data, error } = await getSession();
      if (error){
        console.log(error);
        localStorage.removeItem("loggedIn");
      } else{
        localStorage.loggedIn = true;
        return Comp;
      }
    }
  
    useEffect(()=>{
      getSessionInfo();
    }, []);

    if (localStorage && localStorage.loggedIn) {
      return Comp;
    }
    return <Navigate to='/' />;
};

export default AuthGuard;